import createReactComponent from '../createReactComponent';
export default createReactComponent('minimize-one', 'MinimizeOne', [["path",{"d":"M20 10h-6V4M4 14h6v6M20 4l-6 6m-4 4-6 6","key":"svg-0"}]]);